(ns net.kestec.mhda-pilgrimage.admin.popup.application-delete-popup
  (:require ["@mui/material/Button" :default Button]
            ["@mui/material/Modal" :default Modal]
            ["@mui/material/Grid" :default Grid]
            ["@mui/material/FormLabel" :default FormLabel]
            ["@mui/material/Select" :default Select]
            ["@mui/material/MenuItem" :default MenuItem]
            ["@mui/icons-material/Cancel" :default CancelIcon]
            ["@mui/icons-material/Done" :default DeleteIcon]

            [ajax.core :as ajax]
            [net.kestec.mhda-pilgrimage.db :as-alias db]
            [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as admin-applications-events]
            [net.kestec.mhda-pilgrimage.admin.applications.application-events :as admin-application-events]
            [net.kestec.re-frame.event :as-alias event]
            ["react" :as react]
            [re-frame.core :as rf]
            [reagent.core :as r]))




(defn claim-delete-form* [application]
  (let [applicationId (:id application)]
    (println "claim-delete-form* " application)

    [:div
     {:class "modal"
      :style {:min-width "600px"}}
     [:h4 "Antrag `" (:shown_first_name application) " " (:shown_last_name application)"`"]
     [:div
      "Wollen Sie wirklich diese Anmeldung wirklich löschen?"]
     [:br]
     [:br]

     [:> Button
      {:style     {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(rf/dispatch [::admin-application-events/show-delete-popup nil])
       }
      "Abbrechen"]

     [:> Button
      {:style     {:float "right"}
       :variant   "contained"
       :startIcon (r/as-element [:> DeleteIcon])
       :onClick   (fn []
                    (rf/dispatch [::admin-application-events/delete-application applicationId ])
                    (rf/dispatch [::admin-application-events/show-delete-popup nil]))
       }
      (or @(rf/subscribe [::db/get ::saveButton]) "ok")]
     ]

    ))

(defn application-delete-popup []
  (when-let [application-id @(rf/subscribe [::db/get ::db/show-delete-popup])]
    (let [application (first (filter #(= application-id (:id %)) @(rf/subscribe [::db/get ::admin-applications-events/admin-applications])))]
      [:> Modal {:aria-labelledby  "simple-modal-title"
                 :aria-describedby "simple-modal-description"
                 :style            {:display        "flex"
                                    :marginRight    "auto"
                                    :marginLeft     "auto"
                                    :alignItems     "center"
                                    :justifyContent "center"}
                 :open             (if (nil? application-id) false true)

                 }
       [:f> claim-delete-form* application]]
      )))